export enum ClickTypeEnum {
  加成挂件 = 0,
  规则挂件,
  闯关任务挂件,
  分享按钮,
  海选榜单加成卡,
  去送礼,
  子榜下拉按钮,
  吸底贡献按钮,
  榜单右侧展开按钮,
  半屏去使用,
  半屏主播去提醒,
  半屏公会长去提醒,
  吸底去使用,
  吸底去提醒,
}

export interface RewardItem {
  name: string
  icon?: string
  quantity?: number | string
  type?: 'leader' | 'anchor'
  /**
   * 展示类型: 1.高价值;2:加成卡;3:特权;4.实物
   */
  show_type?: 1 | 2 | 3 | 4
  /**
   * 奖励数量
   */
  num?: number
  /**
   * 特权 ID
   */
  privilege_id?: number
  privilege_type?: number
  reward_config_id?: number
}
export interface SeaTitleProps {
  /** 标题类型，支持三种样式：SSS（金色）、SS（蓝色）、S（铜色） */
  type: GroupEnum
  /** 标题文字内容 */
  title: string
  /** 自定义类名 */
  className?: string
}

export enum ActivityStageEnum {
  hot = 0,
  sea = 1,
  up = 2,
  end = 3,
}

export enum GroupEnum {
  SSSS = 1,
  SSS = 2,
  SS = 3,
  S = 4,
}

export interface ActivityMemberV2 {
  /**
   * 成员 id
   */
  id: number | string
  /**
   * 成员昵称
   */
  name: string
  /**
   * 成员 zyId
   */
  zy_id: string
  /**
   * 成员头像
   */
  avatar: string
  /**
   * 成员性别（0:未知，1:男，2:女）
   */
  gender: number
}

export interface RdsRankInfoV2 {
  /**
   * 成员信息，可能为 null
   */
  member_info?: ActivityMemberV2 | null
  /**
   * 排名
   */
  rank: number
  /**
   * 贡献积分
   */
  score: number
}

export interface UnionContestRewardItem extends RewardItem {
  /**
   * 奖励名称
   */
  name: string
  /**
   * 奖励图标地址
   */
  icon: string

  reward_config_id?: number
}

export interface UnionContestRewardDetail {
  /**
   * 奖励标签
   */
  tag: string
  /**
   * 奖励内容列表
   */
  items: UnionContestRewardItem[]
}

export interface UnionContestTaskConfigItem {
  /**
   * 任务段位（段位序号）
   */
  level: number
  /**
   * 任务目标积分
   */
  target: number
  /**
   * 队长奖励，可能为 null
   */
  leader_reward?: UnionContestRewardDetail | null
  /**
   * 主播奖励列表（可能为空数组）
   */
  anchor_rewards: UnionContestRewardDetail[]
  /**
   * 是否当前任务
   */
  is_current: boolean
  /**
   * 当前任务积分进度（非当前任务为 0）
   */
  current_score: number
  /**
   * 当前任务倒计时秒数（过期为 0）
   */
  countdown: number
  /**
   * 当前任务贡献 TOP10（仅当前任务返回）
   */
  top_contributors: RdsRankInfoV2[]
  /**
   * 是否已解锁任务
   */
  is_unlocked: boolean
  /**
   * 无限任务完成次数
   */
  endless_mode_times: number
}

export interface UnionContestTaskListResponse {
  /**
   * 公会所在分组名称
   */
  group_name: string
  /**
   * 任务配置列表
   */
  tasks: UnionContestTaskConfigItem[]

  activity_id: number
}

export interface UnionContestTaskState {
  done?: boolean // 数据跟新标志
  /**
   * 接口请求加载态
   */
  loading: boolean
  /**
   * 公会所在分组名称
   */
  groupName: string
  /**
   * 任务配置列表
   */
  list: UnionContestTaskConfigItem[]
  /**
   * 活动id
   */
  activity_id: number
  /**
   * 错误信息
   */
  error: string | null
}

export interface UnionContestCardItemResponse {
  /**
   * 加成卡唯一 ID
   */
  card_id: number
  /**
   * 加成比例（数值）
   */
  card_coins: number
  /**
   * 有效时长（小时）
   */
  card_hours: number
  /**
   * 过期时间戳（秒）
   */
  expire_ts: number
  /**
   * 状态：0 未使用，1 已使用，2 过期
   */
  ustatus: number
  /**
   * 加成卡适用时间
   */
  use_time: string
  /**
   * 加成卡图片
   */
  card_icon: string
}

export interface UnionContestCardInfoResponse {
  /**
   * 是否存在生效中的加成 buff
   */
  is_buff_active: boolean
  /**
   * 比赛阶段：0 预赛，1 决赛
   */
  competition_phase: number
  /**
   * 决赛开赛时间（格式：YYYY-MM-DD HH:MM:SS）
   */
  final_contest_start_time: string
  /**
   * 当前生效的加成比例
   */
  current_ratio: number
  /**
   * 当前 buff 到期时间戳（秒）
   */
  buff_expire_ts: number
  /**
   * 用户身份：0 非主播，1 普通主播，2 公会长/管理
   */
  user_identity: number
  /**
   * 当前加成卡列表
   */
  card_list: UnionContestCardItemResponse[]
  /**
   * 下一页 offset
   */
  new_offset: number
  /**
   * 是否还有更多数据
   */
  more: boolean
  /**
   * 错误提示（异常才返回）
   */
  err_msg?: string
}

export interface UnionContestCardRequestParams {
  offset?: number
  limit?: number
}

export interface UnionContestCardState {
  /**
   * 是否存在生效中的加成 buff
   */
  is_buff_active: boolean
  /**
   * 比赛阶段：0 预赛，1 决赛
   */
  competition_phase: number
  /**
   * 决赛开赛时间（格式：YYYY-MM-DD HH:MM:SS）
   */
  final_contest_start_time: string
  /**
   * 当前生效的加成比例
   */
  current_ratio: number
  /**
   * 当前 buff 到期时间戳（秒）
   */
  buff_expire_ts: number
  /**
   * 用户身份：0 非主播，1 普通主播，2 公会长/管理
   */
  user_identity: number
  /**
   * 当前加成卡列表
   */
  card_list: UnionContestCardItemResponse[]
  /**
   * 下一页 offset
   */
  new_offset: number
  /**
   * 是否还有更多数据
   */
  more: boolean
  /**
   * 错误提示（异常才返回）
   */
  err_msg?: string
  /**
   * 加成卡未使用个数
   */
  count: number
  /**
   * 是否可以提醒公会长使用加成卡
   */
  is_remind_can_use: boolean
  /**
   * 公会长是否可以设置提醒自己决赛开始自动提醒
   */
  is_leader_remind_can_use: boolean
}

export interface UnionContestCardStoreState {
  /**
   * 加成卡信息加载态
   */
  loading: boolean
  /**
   * 加成卡信息错误
   */
  error: string | null
  /**
   * 加成卡信息实体
   */
  data: UnionContestCardState
}

/**
 * 榜单公会信息
 */
export interface UnionInfo {
  /**
   * 公会 icon
   */
  union_icon: string
  /**
   * 榜单排名
   */
  rank_no: number
  /**
   * 当前积分与前一名的差距
   */
  gap_with_prev: number
  /**
   * 奖励列表
   */
  rewards: Array<{
    /**
     * 奖励 icon
     */
    view_icon: string
    /**
     * 奖励名称
     */
    toast_name: string
  }>
}

/**
 * 我的公会信息
 */
export interface MyUnionInfo {
  /**
   * 公会 icon
   */
  union_icon: string
  /**
   * 榜单排名
   */
  rank_no: number
  /**
   * 当前积分与前一名的差距
   */
  gap_with_prev: number
}

/**
 * 活动礼物信息
 */
export interface ActivityGiftItem {
  /**
   * 礼物 ID
   */
  gift_id: number
  /**
   * 礼物名称
   */
  name: string
  /**
   * 礼物图标
   */
  avatar: string
}

/**
 * 2025年公会赛组件信息响应
 */
export interface UnionContestWidgetInfoResponse {
  /**
   * 错误码
   */
  err_msg?: string
  /**
   * 活动阶段：0预热、1海选、2决赛
   */
  activity_stage: ActivityStageEnum
  /**
   * 活动日期范围数组 [开始日期, 结束日期]
   */
  date_range: string[]
  /**
   * 榜首公会信息
   */
  top1_union_info?: UnionInfo
  /**
   * 我的公会信息
   */
  my_union_info?: MyUnionInfo
  /**
   * 是否为公会主播
   */
  is_anchor: boolean
  /**
   * 判断是否为主播的字段
   */
  if_my_union_info: boolean
  /**
   * 所有组
   */
  final_stage_all_groups: string[]
  /**
   * 自己组
   */
  final_stage_group: string
  /**
   * 决赛时间范围
   */
  final_stage_range: string[]
  /**
   * 海选赛时间范围
   */
  selection_stage_range: string[]
  /**
   * 活动礼物列表
   */
  activity_gift_list?: ActivityGiftItem[]
  /**
   * 分区决赛分组对应海选赛排名范围
   */
  final_groups_rank_range?: any
  /**
   * 非主播默认分组定位
   */
  default_final_group: string
  /**
   * 我所在公会是否加速中
   */
  is_my_union_speeding: boolean
  /**
   * 当前生效中的加成卡icon
   */
  my_union_speed_card_icon: string
  /**
   * 当前生效中的加成卡倒计时
   */
  my_union_speed_expire_ts: number
  /**
   * 当前公会加速状态;eg:注意:活动礼物默认有1.1倍加成;普通礼物是1.0倍
      如果公会1.2倍加成卡生效中，当前礼物是活动礼物，加成倍数:1.2
   */
  my_union_speed_odds?: number
  /**
   * 活动id
   */
  activity_id?: number
  /**
   * 房间id
   */
  room_id?: number
  /**
   * 活动主页面入口
   */
  annual_activity_homepage_url?: string
  /**
   * 活动回顾页面地址
   */
  activity_review_url?: string
}

/**
 * 组件信息 Store 状态
 */
export interface UnionContestWidgetStoreState {
  /**
   * 加载态
   */
  loading: boolean
  /**
   * 错误信息
   */
  error: string | null
  /**
   * 组件信息数据
   */
  data: UnionContestWidgetInfoResponse | null
}

export interface RewardBasicInfo {
  show_type: number // 1:高价值;2:加成卡；3:特权；4:实物奖励
  name: string // 奖励名称
  icon: string // 	奖励图标URL
  reward_config_id: number // 	活动后台奖励配置ID
  privilege_id: number // 特权ID
  privilege_type: number // 特权类型 1:进场特效;2:头像框;3:弹幕气泡;4:亲密卡;5:礼物
  num: number // 角标数量
}

// 海选阶段信息
export interface UnionContestWarmupSelectionInfo {
  reward_topn: number // 最大{topn}公会获得奖励
  reward_coin_range: [number, number] // 奖励金币范围(最小,最大)
}

// 决赛阶段信息
export interface UnionContestWarmupFinalStageRewardItem {
  group_name: string // 分组名称
  top1_union_leader_reward: RewardBasicInfo[] // Top1公会公会长奖励列表
  top1_union_anchor_rewards: RewardBasicInfo[][] // Top1公会主播奖励列表
  rank_reward_nos: number[]
}

// 挑战任务奖励信息
export interface UnionContestWarmupChallengeTaskRewardItem {
  task_level: number // 任务等级
  top1_union_leader_reward: RewardBasicInfo[] // Top1公会公会长奖励列表
  top1_union_anchor_rewards: RewardBasicInfo[][] // Top贡献主播奖励列表
}

export interface UnionContestWarmupActivityGift {
  gift_id: number
  avatar: string
  name: string
}
export interface UnionContestWarmupState {
  activity_id: number // 活动id
  activity_gifts: UnionContestWarmupActivityGift[] // 活动规则礼物
  final_stage_range: [string, string] // 决赛阶段起止日期
  selection_stage_range: [string, string] // 海选阶段起止日期
  selection_stage_info: UnionContestWarmupSelectionInfo // 海选阶段信息
  final_stage_info: UnionContestWarmupFinalStageRewardItem[] // 决赛阶段信息
  challenge_task_reward_info: UnionContestWarmupChallengeTaskRewardItem[] // 挑战任务奖励信息
}

export interface NewYearUnionGameState {
  task: UnionContestTaskState
  card: UnionContestCardStoreState
  widget: UnionContestWidgetStoreState
  warmup: UnionContestWarmupState
}
